import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.143 10.271v-.937c1.26-.705 2.286-2.463 2.286-4.222C11.429 2.29 11.429 0 8 0S4.571 2.29 4.571 5.112c0 1.76 1.027 3.517 2.286 4.222v.937C2.981 10.586 0 12.48 0 14.77h16c0-2.289-2.98-4.183-6.857-4.498z" fill="#666" /></svg>;